import React, { useEffect, useState } from "react";
import { usersResource } from "../../helpers/configRoutes/backend_helper";
import { Link, useNavigate } from "react-router-dom";
import PreviewPDF from "../../components/modal/PreviewPdf";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import DataTableElement from "../../components/elements/DataTableElement";
import { operatorColumns } from "./Columns";

const Operators = () => {
    const navigate = useNavigate();

    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: "Delete operator",
        loading: false,
        textLoad: "Processing...",
        id: null,
    });

    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading operators...",
    });

    const [filters] = useState({
        perPage: 20,
        page: 1,
        operator: true, // ya lo traías, lo respetamos
    });

    const [users, setUsers] = useState([]);

    const [modalPdf, setModalPdf] = useState({
        show: false,
        url: "",
        title: "",
    });

    useEffect(() => {
        const getOperators = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));

            const response = await usersResource("get", { params: filters });

            if (response.status) {
                setUsers(response.users || []);
            }

            setTableLoad((prev) => ({ ...prev, show: false }));
        };

        getOperators();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteUser = async () => {
        setModalConfirm((prev) => ({ ...prev, loading: true }));

        const response = await usersResource("del", {}, modalConfirm.id);

        if (response.status) {
            setUsers((prev) => prev.filter((u) => u.id !== modalConfirm.id));
        }

        setModalConfirm({
            show: false,
            title: "Delete operator",
            loading: false,
            textLoad: "Processing...",
            id: null,
        });
    };

    const cols = operatorColumns(navigate, setModalConfirm, setModalPdf);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Operators
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage operators, licenses and DOT documentation in one place.
                        </p>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                            Total operators:{" "}
                            <span className="font-semibold text-cs-dark">
                                {users.length}
                            </span>
                        </div>
                        <Link
                            to="/operator-upadd"
                            className="
                                inline-flex items-center gap-2
                                px-4 py-2.5
                                rounded-xl
                                bg-cs-primary hover:bg-cs-primary-hover
                                text-white text-sm font-medium
                                shadow-md hover:shadow-lg
                                transition-all
                            "
                        >
                            <span className="material-symbols-outlined text-sm">add</span>
                            Add operator
                        </Link>
                    </div>
                </div>

                {/* Table */}
                <div
                    className="
                        bg-cs-bg border border-cs-border rounded-2xl
                        shadow-sm px-2 py-2
                    "
                >
                    <DataTableElement
                        columns={cols}
                        items={users}
                        tableLoad={tableLoad}
                    />
                </div>
            </div>

            {/* Modals */}
            <PreviewPDF modal={modalPdf} setModal={setModalPdf} />

            <ConfirmDeleteModal
                modal={modalConfirm}
                setModal={setModalConfirm}
                action={deleteUser}
            />
        </>
    );
};

export default Operators;
